import React, { Fragment, useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import * as FaIcons from "react-icons/fa";
import * as AiIcons from "react-icons/ai";
import { SidebarDataAdmin } from "./SidebarDataAdmin";
import { SidebarDataGestor } from "./SidebarDataGestor";
import { SidebarDataComercial } from "./SidebarDataComercial";
import SubMenu from "./SubMenu";
import { IconContext } from "react-icons/lib";
import Cookies from "universal-cookie";
import logo from "../img/Logo-Icontec-CotizApp_WH.png";

const Nav = styled.div`
  background: #0085ca;
  height: 80px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  width: 100%;
  z-index: 10;
`;

const NavIcon = styled(Link)`
  margin-left: 2rem;
  font-size: 2rem;
  height: 80px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

const Logo = styled.img`
  margin-right: 2rem;
`;

const SidebarNav = styled.nav`
  background: #0085ca;
  width: 250px;
  height: 100vh;
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 0;
  left: ${({ sidebar }) => (sidebar ? "0" : "-100%")};
  transition: 350ms;
  z-index: 10;
  overflow-y: auto;
`;

const SidebarWrap = styled.div`
  width: 100%;
`;

const Sidebar = () => {
  const [sidebar, setSidebar] = useState(false);

  const showSidebar = () => setSidebar(!sidebar);
  const cookie = new Cookies();

  const renderSidebarContent = (sidebarData) => (
    <Fragment>
      <IconContext.Provider value={{ color: "#fff" }}>
        <Nav>
          <NavIcon to="#">
            <FaIcons.FaBars onClick={showSidebar} />
          </NavIcon>
          <Logo src={logo} width="20%" />
        </Nav>
        <SidebarNav sidebar={sidebar}>
          <SidebarWrap>
            <NavIcon to="#">
              <AiIcons.AiOutlineCloseCircle onClick={showSidebar} />
            </NavIcon>
            {sidebarData.map((item, index) => (
              <SubMenu
                item={item}
                key={index}
                closeSidebar={() => setSidebar(false)}
              />
            ))}
          </SidebarWrap>
        </SidebarNav>
      </IconContext.Provider>
    </Fragment>
  );

  if (cookie.get("tipo_Usuario") === "1") {
    return renderSidebarContent(SidebarDataAdmin);
  }
  if (cookie.get("tipo_Usuario") === "2") {
    return renderSidebarContent(SidebarDataGestor);
  }
  if (cookie.get("tipo_Usuario") === "3") {
    return renderSidebarContent(SidebarDataComercial);
  }

  return null;
};

export default Sidebar;
